import React, { useCallback, useMemo, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import { LeftArrowIcon } from "../../common/icons/LeftArrowIcon";
import { RightArrowIcon } from "../../common/icons/RightArrowIcon";
import classNames from "classnames";
import { useFilteredLoginLogList } from "../../../hooks/admin/login_log/useFilteredLoginLogList";

export const LoginLogGraph = React.memo(function LoginLogGraph() {
    const { loginLogList } = useFilteredLoginLogList();

    const today = useMemo(() => DateObject.today(), []);

    const [headerDateMax, setHeaderDateMax] = useState(today);

    const dateList = useMemo(() => [
        headerDateMax.addDay(-6),
        headerDateMax.addDay(-5),
        headerDateMax.addDay(-4),
        headerDateMax.addDay(-3),
        headerDateMax.addDay(-2),
        headerDateMax.addDay(-1),
        headerDateMax
    ], [headerDateMax]);

    const [selectedDate, setSelectedDate] = useState(today);

    const graphDataList = useMemo(() => {
        const loginLogListFilterByDate = loginLogList.filter(loginLog => loginLog.time.date.equals(selectedDate));

        const graphDataList = [];

        for (let i = 0; i < 24; i++) {
            const time = `${i.toString().padStart(2, "0")}:00`;
    
            graphDataList.push({
                time: time,
                value: loginLogListFilterByDate.filter(loginLog => loginLog.time.time.hour === i).length
            });
        }

        return graphDataList;
    }, [loginLogList, selectedDate]);

    const handleLeftArrowClicked = useCallback(() => {
        setHeaderDateMax(headerDateMax.addDay(-7));
        setSelectedDate(headerDateMax.addDay(-7));
    }, [headerDateMax]);

    const handleRightArrowClicked = useCallback(() => {
        if (headerDateMax.isLessThan(today)) {
            setHeaderDateMax(headerDateMax.addDay(7));
            setSelectedDate(headerDateMax.addDay(7));
        }
    }, [headerDateMax, today]);

    const headerDate = useCallback((date: DateObject) => {
        const className = classNames("header_date", { "selected": date.equals(selectedDate) });

        return (
            <div key={date.format()} className={className} onClick={() => setSelectedDate(date)}>
                {`${date.format("/").substring(5,)}(${date.getDayOfWeek()})`}
            </div>
        );
    }, [selectedDate]);

    const tooltipContent = useCallback(({ payload }: any) => {
        if (!payload || !payload[0] || !payload[0].value) return null;

        const time = payload[0].payload.time;
        const value = payload[0].payload.value;

        return (
            <div className={"login_count_tooltip"}>
                <div className={"time"}>{time}〜</div>
                <div className={"value"}>{value}回</div>
            </div>
        );
    }, []);

    return (
        <div className={"graph_area"}>
            {/* 日付 */}
            <div className={"date_selector"}>
                <button onClick={handleLeftArrowClicked}>
                    <LeftArrowIcon />
                </button>
                {dateList.map(headerDate)}
                <button onClick={handleRightArrowClicked} disabled={headerDateMax.isEqualsOrGreaterThanToday()}>
                    <RightArrowIcon />
                </button>
            </div>

            {/* グラフ */}
            <ResponsiveContainer width={"50%"} height={200}>
                <BarChart data={graphDataList} barSize={12} barGap={8}>
                    <XAxis dataKey={"time"} interval={2} />
                    <YAxis hide />
                    <Bar dataKey={"value"} fill="#75777E" radius={[8, 8, 8, 8]} />
                    <Tooltip cursor={false} content={tooltipContent} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
});
